// geoRedirect.js
// Client-side module to detect user's country, check for matching branch site,
// and show a one-time redirect prompt (dismissible for 30 days via localStorage).
// Reads country from Cloudflare's geo_hint cookie, with ?force-country= query param override.

const DISMISSAL_KEY = 'geoPromptDismissed';
const DISMISSAL_DURATION_MS = 30 * 24 * 60 * 60 * 1000;	// 30 days
const DEBUG_COUNTRY_CODE = "gb";
const devMode = document.documentElement.dataset.devMode;

function getCookie(name)
{
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
	return null;
}

function handleGeoRedirect()
{
	if (devMode) console.log('handleGeoRedirect()');

	// Skip if recently dismissed
	const dismissalData = localStorage.getItem(DISMISSAL_KEY);
	if (dismissalData)
	{
		const { timestamp } = JSON.parse(dismissalData);
		if (Date.now() - timestamp < DISMISSAL_DURATION_MS)
		{
			if (devMode) console.log('Geo-location prompt dismissed in the last 30 days.');
			return;
		}
	}

	let country;

	// Allow override via URL param: ?force-country=gb (overrides cookie entirely)
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has('force-country'))
	{
		country = urlParams.get('force-country').toLowerCase().trim();
		if (devMode) console.log(`Using forced country from query param: ${country}`);
	}
	else
	{
		// Read country from Cloudflare's geo_hint cookie
		const geoCookie = getCookie('geo_hint');
		if (geoCookie)
		{
			country = geoCookie.toLowerCase();
			if (devMode) console.log(`Using country from geo_hint cookie: ${country}`);
		}
		else
		{
			if (devMode) console.warn('geo_hint cookie not found; using fallback of ' + DEBUG_COUNTRY_CODE);
			country = DEBUG_COUNTRY_CODE;
		}
	}

	// Normalize just in case
	country = country.toLowerCase();

	// Find matching branch link
	const link = document.querySelector(`.jsBranchLink[data-country-code="${country}"]`);

	if (!link)
	{
		if (devMode) console.log(`No branch found for country code: ${country}`);
		return;
	}
	else
	{
		if (devMode) console.log(`Found matching branch for country code: ${country}`);
		const localBranchDialog = document.querySelector('.jsLocalBranchPrompt');
		const localBranchDialogIcon = localBranchDialog.querySelector('.jsLocalBranchIcon');
		const localBranchDialogLink = localBranchDialog.querySelector('.jsLocalBranchLink');
		const localBranchDialogCountryNameArr = localBranchDialog.querySelectorAll('.jsLocalBranchCountryName');
		const localBranchDialogCloseBtn = localBranchDialog.querySelector('.jsCloseDialog');


		// Set image
		localBranchDialogIcon.src = link.querySelector('img').src;
		// Set name
		localBranchDialogCountryNameArr.forEach(countryNameEl =>
		{
			countryNameEl.innerHTML = link.dataset.countryName;
		});
		// Set URL
		localBranchDialogLink.href = link.href;

		localBranchDialogCloseBtn.addEventListener('click', () =>
		{
			// User wants to stay; remember for 30 days
			const now = Date.now();
			localStorage.setItem(DISMISSAL_KEY, JSON.stringify({ timestamp: now }));
			if (devMode) console.log('Geo prompt dismissed; saved for 30 days');
		});

		// localBranchDialog.addEventListener('close', () =>
		// {
		// 	let branchesMenu = document.querySelector(".jsToggleMegamenu[data-dialog-id='megamenu__branches']");
		// 	branchesMenu.classList.add('animate-bounce');
		// 	setTimeout(() =>
		// 	{
		// 		branchesMenu.classList.remove('animate-bounce');
		// 	}, 1250);

		// });

		// Show prompt
		localBranchDialog.showModal();

	}

}

// Run once DOM is ready
document.addEventListener('DOMContentLoaded', handleGeoRedirect);